module.exports = __webpack_public_path__ + "img/save-white.b86743dd.svg";